export const SupportWelcomeFormFields = {
  agree: {
    name: 'lego-submit-ticket-agree',
    required: true,
    excludeFromPayload: true,
    value: true,
  },
};
